/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Row, Col, Form, Input, Button, Select, message, Radio } from "antd";
import { HeaderWithBottomLine } from "./HeaderWithBottomLine";
import axios from "axios";
import { APIs } from "../../../utils/worker";
import { camelCase } from "../../../utils";
import {
  capitalise,
  capitalize,
  firstLetterCapitalise,
  capitaliseWithHyphen,
} from "../../../utils";

export const BasicDetails = ({
  setLoading,
  form,
  handlerHubId,
  isEdit,
  cpResponse,
  disableInputField,
}) => {
  const [premises, setPremises] = useState([]);
  const [isMiniHub, setIsMiniHub] = useState(false);
  console.log(disableInputField);
  useEffect(() => {
    if (isEdit?.mineHubConnected !== undefined) {
      setIsMiniHub(isEdit?.mineHubConnected);
    }
  }, [isEdit]);

  useEffect(() => {
    setIsMiniHub(cpResponse?.premiseDto?.mineHubConnected);
  }, [cpResponse]);

  const radioGap = {
    display: "flex",
    columnGap: "4rem",
  };
  const { Option } = Select;

  // let miniHub = [
  //   {
  //     value: "AHMEDABAD MONDEAL SQUARE HUB",
  //     label: "AHMEDABAD MONDEAL SQUARE HUB",
  //   },
  //   {
  //     value: "AHMEDABAD BHULABHAI HUB",
  //     label: "AHMEDABAD BHULABHAI HUB",
  //   },
  //   {
  //     value: "AHMEDABAD NEHRUNAGAR HUB",
  //     label: "AHMEDABAD NEHRUNAGAR HUB",
  //   },
  //   { value: "ALLEPPEY MINI HUB", label: "LLEPPEY MINI HUB" },
  //   {
  //     value: "PRAYAGRA ANKLESHWAR HUB",
  //     label: "RAYAGRA ANKLESHWAR HUB",
  //   },
  //   { value: " MAHADEVAPURA HUB", label: "MAHADEVAPURA HUB" },
  //   {
  //     value: " BENGALURU-BANASHANKARI HUB",
  //     label: "BENGALURU-BANASHANKARI HUB",
  //   },
  //   { value: " BENGALURU HSR HUB", label: "BENGALURU HSR HUB" },
  //   { value: " WILSON GARDEN HUB", label: "WILSON GARDEN HUB" },
  //   { value: " YESHWANTHPUR HUB", label: "YESHWANTHPUR HUB" },
  //   { value: " BHAVNAGAR MINI HUB", label: "BHAVNAGAR MINI HUB" },
  //   { value: " BHIWANDI HUB", label: "BHIWANDI HUB" },
  //   { value: " CHENNAI KOYAMBEDU HUB", label: "CHENNAI KOYAMBEDU HUB" },
  //   { value: " CHENNAI CITY HUB", label: "CHENNAI CITY HUB" },
  //   { value: " POONAMALEE HUB", label: "POONAMALEE HUB" },
  //   {
  //     value: " DELHI JAHANGIRPURI HUB",
  //     label: "DELHI JAHANGIRPURI HUB",
  //   },
  //   {
  //     value: " DELHI YASHWANT PLACE HUB",
  //     label: "DELHI YASHWANT PLACE HUB",
  //   },
  //   { value: " DELHI GANDHINAGAR HUB", label: "DELHI GANDHINAGAR HUB" },
  //   { value: " DELHI NEHRU PLACE HUB", label: "DELHI NEHRU PLACE HUB" },
  //   {
  //     value: " DELHI PUNJABI BAUGH HUB",
  //     label: "DELHI PUNJABI BAUGH HUB",
  //   },
  //   { value: "DELHI JHANDEWALAN HUB", label: "ELHI JHANDEWALAN HUB" },
  //   { value: " DELHI JANAKPURI HUB", label: "DELHI JANAKPURI HUB" },
  //   { value: " PITHAMPUR HUB", label: "PITHAMPUR HUB" },
  //   { value: " DHAR HUB", label: "DHAR HUB" },
  //   { value: " FARIDABAD HUB", label: "FARIDABAD HUB" },
  //   { value: " GHAZIABAD HUB", label: "GHAZIABAD HUB" },
  //   { value: " GORAKHPUR HUB", label: "GORAKHPUR HUB" },
  //   { value: " GURGAON HUB", label: "GURGAON HUB" },
  //   { value: " GWALIOR HUB", label: "GWALIOR HUB" },
  //   { value: " HARIDWAR HUB", label: "HARIDWAR HUB" },
  //   { value: " HISAR MINI HUB", label: "HISAR MINI HUB" },
  //   { value: " HOWRAH HUB", label: "HOWRAH HUB" },
  //   {
  //     value: " HYDERABAD-KOMPALLY HUB",
  //     label: "HYDERABAD-KOMPALLY HUB",
  //   },
  //   { value: " HYDERABAD-TARNAKA HUB", label: "HYDERABAD-TARNAKA HUB" },
  //   {
  //     value: " HYDERABAD-MALAKPET HUB",
  //     label: "HYDERABAD-MALAKPET HUB",
  //   },
  //   { value: " HYDERABAD-MIYAPUR HUB", label: "HYDERABAD-MIYAPUR HUB" },
  //   {
  //     value: " HYDERABAD-SAIFABAD HUB",
  //     label: "HYDERABAD-SAIFABAD HUB",
  //   },
  //   { value: " JABALPUR HUB", label: "JABALPUR HUB" },
  //   { value: " JAIPUR CITY HUB", label: "JAIPUR CITY HUB" },
  //   { value: " JAMSHEDPUR MINI HUB", label: "JAMSHEDPUR MINI HUB" },
  //   { value: " JHANSI HUB", label: "JHANSI HUB" },
  //   { value: " JODHPUR HUB", label: "JODHPUR HUB" },
  //   { value: " KANNUR MINI HUB", label: "KANNUR MINI HUB" },
  //   {
  //     value: " KOLKATA TOLLYGUNGE HUB",
  //     label: "KOLKATA TOLLYGUNGE HUB",
  //   },
  //   { value: " KOLKATA BARASAT HUB", label: "KOLKATA BARASAT HUB" },
  //   { value: " SERAMPORE HUB", label: "SERAMPORE HUB" },
  //   { value: " KOLLAM MINI HUB", label: "KOLLAM MINI HUB" },
  //   { value: " KOTTAKKAL MINI HUB", label: "KOTTAKKAL MINI HUB" },
  //   { value: " KOTTAYAM HUB", label: "KOTTAYAM HUB" },
  //   { value: " LUDHIANA HUB", label: "LUDHIANA HUB" },
  //   { value: " MADURAI HUB", label: "MADURAI HUB" },
  //   { value: " MALDA MINI HUB", label: "MALDA MINI HUB" },
  //   { value: " MEERUT HUB", label: "MEERUT HUB" },
  //   { value: " MORBI MINI HUB", label: "MORBI MINI HUB" },
  //   { value: " MUMBAI CHAKALA HUB", label: "MUMBAI CHAKALA HUB" },
  //   { value: " THANE HUB", label: "THANE HUB" },
  //   { value: " ANDHERI HUB", label: "ANDHERI HUB" },
  //   { value: " DADAR HUB", label: "DADAR HUB" },
  //   { value: " VASHI HUB", label: "VASHI HUB" },
  //   { value: " NOIDA HUB", label: "NOIDA HUB" },
  //   { value: " PALAKKAD MINI HUB", label: "PALAKKAD MINI HUB" },
  //   { value: " CHAKAN HUB", label: "CHAKAN HUB" },
  //   { value: " PUNE CITY HUB", label: "PUNE CITY HUB" },
  //   { value: " PUNE PIMPRI HUB", label: "PUNE PIMPRI HUB" },
  //   { value: " PUNE WARJE HUB", label: "PUNE WARJE HUB" },
  //   { value: " AMRITSAR HUB", label: "AMRITSAR HUB" },
  //   { value: " ROHTAK HUB", label: "ROHTAK HUB" },
  //   { value: " RUDRAPUR HUB", label: "RUDRAPUR HUB" },
  //   { value: " SALEM HUB", label: "SALEM HUB" },
  //   { value: " SONIPAT HUB", label: "SONIPAT HUB" },
  //   { value: " SURAT-BELGIUM HUB", label: "SURAT-BELGIUM HUB" },
  //   { value: " THRISSUR HUB", label: "THRISSUR HUB" },
  //   { value: " TRICHY HUB", label: "TRICHY HUB" },
  //   { value: " TRIVANDRUM MINI HUB", label: "TRIVANDRUM MINI HUB" },
  //   { value: " VARANASI HUB", label: "VARANASI HUB" },
  //   { value: " VASAI HUB", label: "VASAI HUB" },
  //   // { value: "", label:" },
  // ];

  let miniHub = [
    { label: "AGRA HUB", value: "AGRA HUB" },
    {
      label: "AHMEDABAD MONDEAL SQUARE HUB",
      value: "AHMEDABAD MONDEAL SQUARE HUB",
    },
    {
      label: "AHMEDABAD NEHRUNAGAR HUB",
      value: "AHMEDABAD NEHRUNAGAR HUB",
    },
    { label: "ALLEPPEY MINI HUB", value: "ALLEPPEY MINI HUB" },
    { label: "AMRITSAR HUB", value: "AMRITSAR HUB" },
    { label: "ANKLESHWAR HUB", value: "ANKLESHWAR HUB" },
    { label: "BATHINDAHUB", value: "BATHINDAHUB" },
    { label: "BENGALURU HSR HUB", value: "BENGALURU HSR HUB" },
    {
      label: "BENGALURU-BANASHANKARI HUB",
      value: "BENGALURU-BANASHANKARI HUB",
    },
    { label: "BHAVNAGAR MINI HUB", value: "BHAVNAGAR MINI HUB" },
    { label: "CHAKAN HUB", value: "CHAKAN HUB" },
    { label: "CHENNAI CITY HUB", value: "CHENNAI CITY HUB" },
    { label: "CHENNAI KOYAMBEDU HUB", value: "CHENNAI KOYAMBEDU HUB" },
    { label: "DELHI GANDHINAGAR HUB", value: "DELHI GANDHINAGAR HUB" },
    { label: "DELHI JAHANGIRPURI HUB", value: "DELHI JAHANGIRPURI HUB" },
    { label: "DELHI JANAKPURI HUB", value: "DELHI JANAKPURI HUB" },
    { label: "DELHI JHANDEWALAN HUB", value: "DELHI JHANDEWALAN HUB" },
    { label: "DELHI NEHRU PLACE HUB", value: "DELHI NEHRU PLACE HUB" },
    {
      label: "DELHI PUNJABI BAUGH HUB",
      value: "DELHI PUNJABI BAUGH HUB",
    },
    {
      label: "DELHI YASHWANT PLACE HUB",
      value: "DELHI YASHWANT PLACE HUB",
    },
    { label: "DHAR HUB", value: "DHAR HUB" },
    { label: "DURGAPUR HUB", value: "DURGAPUR HUB" },
    { label: "FARIDABAD HUB", value: "FARIDABAD HUB" },
    { label: "GHAZIABAD HUB", value: "GHAZIABAD HUB" },
    { label: "GORAKHPUR HUB", value: "GORAKHPUR HUB" },
    { label: "GURGAON HUB", value: "GURGAON HUB" },
    { label: "GWALIOR HUB", value: "GWALIOR HUB" },
    { label: "HARIDWAR HUB", value: "HARIDWAR HUB" },
    { label: "HISAR MINI HUB", value: "HISAR MINI HUB" },
    { label: "HYDERABAD CITY HUB", value: "HYDERABAD CITY HUB" },
    { label: "HYDERABAD-KOMPALLY HUB", value: "HYDERABAD-KOMPALLY HUB" },
    { label: "HYDERABAD-MALAKPET HUB", value: "HYDERABAD-MALAKPET HUB" },
    { label: "HYDERABAD-MIYAPUR HUB", value: "HYDERABAD-MIYAPUR HUB" },
    { label: "HYDERABAD-SAIFABAD HUB", value: "HYDERABAD-SAIFABAD HUB" },
    { label: "HYDERABAD-TARNAKA HUB", value: "HYDERABAD-TARNAKA HUB" },
    { label: "JABALPUR HUB", value: "JABALPUR HUB" },
    { label: "JAIPUR CITY HUB", value: "JAIPUR CITY HUB" },
    { label: "JALANDHAR HUB", value: "JALANDHAR HUB" },
    { label: "JAMSHEDPUR MINI HUB", value: "JAMSHEDPUR MINI HUB" },
    { label: "JHANSI HUB", value: "JHANSI HUB" },
    { label: "JODHPUR HUB", value: "JODHPUR HUB" },
    { label: "KANNUR MINI HUB", value: "KANNUR MINI HUB" },
    { label: "KANPUR HUB", value: "KANPUR HUB" },
    { label: "KARNAL HUB", value: "KARNAL HUB" },
    { label: "KOLKATA BARASAT HUB", value: "KOLKATA BARASAT HUB" },
    { label: "KOLKATA CITY HUB", value: "KOLKATA CITY HUB" },
    { label: "KOLKATA TOLLYGUNGE HUB", value: "KOLKATA TOLLYGUNGE HUB" },
    { label: "KOLLAM MINI HUB", value: "KOLLAM MINI HUB" },
    { label: "KOTTAKKAL MINI HUB", value: "KOTTAKKAL MINI HUB" },
    { label: "KOTTAYAM HUB", value: "KOTTAYAM HUB" },
    { label: "MADURAI HUB", value: "MADURAI HUB" },
    { label: "MALDA MINI HUB", value: "MALDA MINI HUB" },
    { label: "MEERUT HUB", value: "MEERUT HUB" },
    { label: "MORBI MINI HUB", value: "MORBI MINI HUB" },
    { label: "MUMBAI CHAKALA HUB", value: "MUMBAI CHAKALA HUB" },
    { label: "NOIDA HUB", value: "NOIDA HUB" },
    { label: "PALAKKAD MINI HUB", value: "PALAKKAD MINI HUB" },
    { label: "PITHAMPUR HUB", value: "PITHAMPUR HUB" },
    { label: "PRAYAGRAJ HUB", value: "PRAYAGRAJ HUB" },
    { label: "PUNE CITY HUB", value: "PUNE CITY HUB" },
    { label: "PUNE PIMPRI HUB", value: "PUNE PIMPRI HUB" },
    { label: "PUNE WARJE HUB", value: "PUNE WARJE HUB" },
    { label: "ROHTAK HUB", value: "ROHTAK HUB" },
    { label: "RUDRAPUR HUB", value: "RUDRAPUR HUB" },
    { label: "SALEM HUB", value: "SALEM HUB" },
    { label: "SERAMPORE HUB", value: "SERAMPORE HUB" },
    { label: "SONIPAT HUB", value: "SONIPAT HUB" },
    { label: "SURAT-BELGIUM HUB", value: "SURAT-BELGIUM HUB" },
    { label: "THANE HUB", value: "THANE HUB" },
    { label: "THRISSUR HUB", value: "THRISSUR HUB" },
    { label: "TRICHY HUB", value: "TRICHY HUB" },
    { label: "TRIVANDRUM MINI HUB", value: "TRIVANDRUM MINI HUB" },
    { label: "VARANASI HUB", value: "VARANASI HUB" },
    { label: "VASAI HUB", value: "VASAI HUB" },
    { label: "VASHI HUB", value: "VASHI HUB" },
    { label: "WILSON GARDEN HUB", value: "WILSON GARDEN HUB" },
    { label: "YESHWANTHPUR HUB", value: "YESHWANTHPUR HUB" },
  ];
  // let motherHubName = [
  //   {
  //     label: "AHMEDABAD ASLALI MOTHER HUB",
  //     value: "AHMEDABAD ASLALI MOTHER HUB",
  //   },
  //   { label: "AHMEDABAD AIRPORT HUB", value: " AHMEDABAD AIRPORT HUB" },
  //   {
  //     label: "AHMEDABAD BHULABHAI HUB",
  //     value: " AHMEDABAD BHULABHAI HUB",
  //   },
  //   { label: "AMBALA HUB", value: " AMBALA HUB" },
  //   { label: "AURANGABAD HUB", value: " AURANGABAD HUB" },
  //   { label: "BADDI HUB", value: " BADDI HUB" },
  //   { label: "BARODA HUB", value: " BARODA HUB" },
  //   { label: "BELGAUM HUB", value: " BELGAUM HUB" },
  //   { label: "MAHADEVAPURA HUB", value: " MAHADEVAPURA HUB" },
  //   { label: "BENGALURU HEBBAL HUB", value: " BENGALURU HEBBAL HUB" },
  //   { label: "BHIWANDI HUB", value: " BHIWANDI HUB" },
  //   { label: "BHOPAL HUB", value: " BHOPAL HUB" },
  //   { label: "BHUB", value: " BHUB" },
  //   { label: "ANESWAR HUB", value: "ANESWAR HUB" },
  //   { label: "CALICUT MINI HUB", value: " CALICUT MINI HUB" },
  //   { label: "CHANDIGARH HUB", value: " CHANDIGARH HUB" },
  //   { label: "CHENNAI AIRPORT HUB", value: " CHENNAI AIRPORT HUB" },
  //   { label: "POONAMALEE HUB", value: " POONAMALEE HUB" },
  //   { label: "COIMBATORE HUB", value: " COIMBATORE HUB" },
  //   { label: "DEHRADUN HUB", value: " DEHRADUN HUB" },
  //   { label: "DELHI AIRPORT HUB", value: " DELHI AIRPORT HUB" },
  //   { label: "DELHI SURFACE HUB", value: " DELHI SURFACE HUB" },
  //   { label: "GUWAHATI HUB", value: " GUWAHATI HUB" },
  //   { label: "HOWRAH HUB", value: " HOWRAH HUB" },
  //   { label: "HUBLI HUB", value: " HUBLI HUB" },
  //   { label: "HYDERABAD-AIRPORT HUB", value: " HYDERABAD-AIRPORT HUB" },
  //   { label: "INDORE HUB", value: " INDORE HUB" },
  //   { label: "JAIPUR HUB", value: " JAIPUR HUB" },
  //   { label: "JAMMU HUB", value: " JAMMU HUB" },
  //   { label: "KUTCH HUB", value: " KUTCH HUB" },
  //   { label: "COCHIN HUB", value: " COCHIN HUB" },
  //   { label: "KOLHAPUR HUB", value: " KOLHAPUR HUB" },
  //   { label: "KOLKATA AIRPORT HUB", value: " KOLKATA AIRPORT HUB" },
  //   { label: "KRISHNAGIRI HUB", value: " KRISHNAGIRI HUB" },
  //   { label: "LUCKNOW HUB", value: " LUCKNOW HUB" },
  //   { label: "LUCKNOW AIRPORT HUB", value: " LUCKNOW AIRPORT HUB" },
  //   { label: "LUDHIANA HUB", value: " LUDHIANA HUB" },
  //   { label: "MEHSANA HUB", value: " MEHSANA HUB" },
  //   { label: "MORADABAD HUB", value: " MORADABAD HUB" },
  //   { label: "ANDHERI HUB", value: " ANDHERI HUB" },
  //   { label: "DADAR HUB", value: " DADAR HUB" },
  //   { label: "VASHI HUB", value: " VASHI HUB" },
  //   { label: "MUMBAI GATEWAY HUB", value: " MUMBAI GATEWAY HUB" },
  //   { label: "NAGPUR HUB", value: " NAGPUR HUB" },
  //   { label: "NASHIK HUB", value: " NASHIK HUB" },
  //   { label: "GOA HUB", value: " GOA HUB" },
  //   { label: "PATNA HUB", value: " PATNA HUB" },
  //   { label: "PONDICHERRY MINI HUB", value: " PONDICHERRY MINI HUB" },
  //   { label: "PUNE AIRPORT HUB", value: " PUNE AIRPORT HUB" },
  //   { label: "PUNE GATEWAY HUB", value: " PUNE GATEWAY HUB" },
  //   { label: "RAIPUR HUB", value: " RAIPUR HUB" },
  //   { label: "RAJKOT HUB", value: " RAJKOT HUB" },
  //   {
  //     label: "RANCHI  SILIGURI  SURAT HUB",
  //     value: "RANCHI  SILIGURI  SURAT HUB",
  //   },
  //   { label: "VAPI HUB", value: " VAPI HUB" },
  //   { label: "VIJAYAWADA HUB", value: " VIJAYAWADA HUB" },
  //   { label: "VISAKHAPATANAM HUB", value: " VISAKHAPATANAM HUB" },
  //   { label: "SRINAGAR HUB (J&K)", value: " SRINAGAR HUB (J&K)" },
  // ];

  // useEffect(() => {
  //   getPremises();
  // }, []);
  let motherHubName = [
    {
      lable: "AHMEDABAD AIRPORT HUB",
      value: "AHMEDABAD AIRPORT HUB",
    },
    {
      lable: "AHMEDABAD BHULABHAI HUB",
      value: "AHMEDABAD BHULABHAI HUB",
    },
    {
      lable: "AMBALA HUB",
      value: "AMBALA HUB",
    },
    {
      lable: "AMBALA HUB",
      value: "AMBALA HUB",
    },

    {
      lable: "AGARA HUB",
      value: "AGARA HUB",
    },
    {
      lable: "GHAZIABAD HUB",
      value: "GHAZIABAD HUB",
    },
    {
      lable: "GORAKHPUR HUB",
      value: "GORAKHPUR HUB",
    },
    {
      lable: "HARIDWAR HUB",
      value: "HARIDWAR HUB",
    },
    {
      lable: "JHANSI HUB",
      value: "JHANSI HUB",
    },
    {
      lable: "KANPUR HUB",
      value: "KANPUR HUB",
    },
    {
      lable: "MEERUT HUB",
      value: "MEERUT HUB",
    },
    {
      lable: "PRAYAGRAJ HUB",
      value: "PRAYAGRAJ HUB",
    },
    {
      lable: "RUDRAPUR HUB",
      value: "RUDRAPUR HUB",
    },
    {
      lable: "VARANASI HUB",
      value: "VARANASI HUB",
    },
    {
      lable: "AURANGABAD HUB",
      value: "AURANGABAD HUB",
    },
    { lable: "JABALPUR HUB", value: "JABALPUR HUB" },
    {
      lable: "BADDI HUB",
      value: "BADDI HUB",
    },
    {
      lable: "BARODA HUB",
      value: "BARODA HUB",
    },
    {
      lable: "BELGAUM HUB",
      value: "BELGAUM HUB",
    },
    {
      lable: "BENGALURU HEBBAL HUB",
      value: "BENGALURU HEBBAL HUB",
    },
    {
      lable: "BHIWANDI HUB",
      value: "BHIWANDI HUB",
    },
    {
      lable: "BHOPAL HUB",
      value: "BHOPAL HUB",
    },
    {
      lable: "CALICUT MINI HUB",
      value: "CALICUT MINI HUB",
    },
    {
      lable: "CHANDIGARH HUB",
      value: "CHANDIGARH HUB",
    },
    {
      lable: "CHENNAI AIRPORT HUB",
      value: "CHENNAI AIRPORT HUB",
    },
    {
      lable: "COCHIN HUB",
      value: "COCHIN HUB",
    },
    {
      lable: "COIMBATORE HUB",
      value: "COIMBATORE HUB",
    },
    {
      lable: "DADAR HUB",
      value: "DADAR HUB",
    },
    {
      lable: "DEHRADUN HUB",
      value: "DEHRADUN HUB",
    },
    {
      lable: "DELHI AIRPORT HUB",
      value: "DELHI AIRPORT HUB",
    },
    {
      lable: "DELHI SURFACE HUB",
      value: "DELHI SURFACE HUB",
    },
    {
      lable: "GOA HUB",
      value: "GOA HUB",
    },
    {
      lable: "GUWAHATI HUB",
      value: "GUWAHATI HUB",
    },
    {
      lable: "HOWRAH HUB",
      value: "HOWRAH HUB",
    },
    {
      lable: "HUBLI HUB",
      value: "HUBLI HUB",
    },
    {
      lable: "HYDERABAD-AIRPORT HUB",
      value: "HYDERABAD-AIRPORT HUB",
    },
    {
      lable: "HYDERABAD MIYPUR HUB",
      value: "HYDERABAD MIYPUR HUB",
    },
    {
      lable: "INDORE HUB",
      value: "INDORE HUB",
    },
    {
      lable: "JAIPUR HUB",
      value: "JAIPUR HUB",
    },
    {
      lable: "JAMMU HUB",
      value: "JAMMU HUB",
    },
    {
      lable: "KOLHAPUR HUB",
      value: "KOLHAPUR HUB",
    },
    {
      lable: "KOLKATA AIRPORT HUB",
      value: "KOLKATA AIRPORT HUB",
    },
    {
      lable: "KRISHNAGIRI HUB",
      value: "KRISHNAGIRI HUB",
    },
    {
      lable: "KUTCH HUB",
      value: "KUTCH HUB",
    },
    {
      lable: "LUCKNOW AIRPORT HUB",
      value: "LUCKNOW AIRPORT HUB",
    },
    {
      lable: "LUCKNOW HUB",
      value: "LUCKNOW HUB",
    },
    {
      lable: "LUDHIANA HUB",
      value: "LUDHIANA HUB",
    },
    {
      lable: "MAHADEVAPURA HUB",
      value: "MAHADEVAPURA HUB",
    },
    {
      lable: "MEHSANA HUB",
      value: "MEHSANA HUB",
    },
    {
      lable: "MORADABAD HUB",
      value: "MORADABAD HUB",
    },
    {
      lable: "MUMBAI GATEWAY HUB",
      value: "MUMBAI GATEWAY HUB",
    },
    {
      lable: "NAGPUR HUB",
      value: "NAGPUR HUB",
    },
    {
      lable: "NASHIK HUB",
      value: "NASHIK HUB",
    },
    {
      lable: "PATNA HUB",
      value: "PATNA HUB",
    },
    {
      lable: "PONDICHERRY MINI HUB",
      value: "PONDICHERRY MINI HUB",
    },
    {
      lable: "POONAMALEE HUB",
      value: "POONAMALEE HUB",
    },
    {
      lable: "PUNE AIRPORT HUB",
      value: "PUNE AIRPORT HUB",
    },
    {
      lable: "PUNE GATEWAY HUB",
      value: "PUNE GATEWAY HUB",
    },
    {
      lable: "RAIPUR HUB",
      value: "RAIPUR HUB",
    },
    {
      lable: "RAJKOT HUB",
      value: "RAJKOT HUB",
    },
    {
      lable: "SRINAGAR HUB (J&K)",
      value: "SRINAGAR HUB (J&K)",
    },
    {
      lable: "VAPI HUB",
      value: "VAPI HUB",
    },
    {
      lable: "VASHI HUB",
      value: "VASHI HUB",
    },
    {
      lable: "VIJAYAWADA HUB",
      value: "VIJAYAWADA HUB",
    },
    {
      lable: "VISAKHAPATANAM HUB",
      value: "VISAKHAPATANAM HUB",
    },
    {
      lable: "AHMEDABAD ASLALI MOTHER HUB",
      value: "AHMEDABAD ASLALI MOTHER HUB",
    },
    {
      lable: "AHMEDABAD BHULABHAI ECOM HUB",
      value: "AHMEDABAD BHULABHAI ECOM HUB",
    },
    {
      lable: "AHMEDABAD CARGO HUB",
      value: "AHMEDABAD CARGO HUB",
    },
    {
      lable: "AHMEDABAD ECOM HUB",
      value: "AHMEDABAD ECOM HUB",
    },
    {
      lable: "AHMEDABAD MITHAKHALI HUB",
      value: "AHMEDABAD MITHAKHALI HUB",
    },
    {
      lable: "ANDHERI ECOM HUB",
      value: "ANDHERI ECOM HUB",
    },
    {
      lable: "BARODA CARGO HUB",
      value: "BARODA CARGO HUB",
    },
    {
      lable: "BARODA ECOM HUB",
      value: "BARODA ECOM HUB",
    },
    {
      lable: "BENGALURU ECOM HUB",
      value: "BENGALURU ECOM HUB",
    },
    {
      lable: "BHIWANDI ECOM HUB",
      value: "BHIWANDI ECOM HUB",
    },
    {
      lable: "BHUBANESWAR HUB",
      value: "BHUBANESWAR HUB",
    },
    {
      lable: "BIHAR ECOM HUB",
      value: "BIHAR ECOM HUB",
    },
    {
      lable: "BILASPUR HUB (CHHATTISGARH)",
      value: "BILASPUR HUB (CHHATTISGARH)",
    },
    {
      lable: "BILASPUR HUB (HARYANA)",
      value: "BILASPUR HUB (HARYANA)",
    },
    {
      lable: "CHENNAI ECOM HUB",
      value: "CHENNAI ECOM HUB",
    },
    {
      lable: "CUTTACK HUB",
      value: "CUTTACK HUB",
    },
    {
      lable: "DADAR ECOM HUB",
      value: "DADAR ECOM HUB",
    },
    {
      lable: "DELHI AIRPORT ECOM HUB",
      value: "DELHI AIRPORT ECOM HUB",
    },
    {
      lable: "DELHI DHULSIRAS HUB",
      value: "DELHI DHULSIRAS HUB",
    },
    {
      lable: "DELHI ECOM HUB",
      value: "DELHI ECOM HUB",
    },
    {
      lable: "DELHI INTERNATIONAL HUB",
      value: "DELHI INTERNATIONAL HUB",
    },
    {
      lable: "DELHI JANAKPURI ECOM HUB",
      value: "DELHI JANAKPURI ECOM HUB",
    },
    {
      lable: "DELHI KAROL BAGH HUB",
      value: "DELHI KAROL BAGH HUB",
    },
    {
      lable: "DELHI MULTAN NAGAR ECOM HUB",
      value: "DELHI MULTAN NAGAR ECOM HUB",
    },
    {
      lable: "FORT ECOM HUB",
      value: "FORT ECOM HUB",
    },
    {
      lable: "GOREGAON MUMBAI ECOM",
      value: "GOREGAON MUMBAI ECOM",
    },
    {
      lable: "GURGAON ECOM HUB",
      value: "GURGAON ECOM HUB",
    },
    {
      lable: "HARYANA HUB",
      value: "HARYANA HUB",
    },
    {
      lable: "HYDERABAD ECOM HUB",
      value: "HYDERABAD ECOM HUB",
    },
    {
      lable: "INDORE ECOM HUB",
      value: "INDORE ECOM HUB",
    },
    {
      lable: "JAIPUR ECOM HUB",
      value: "JAIPUR ECOM HUB",
    },
    {
      lable: "KHARAGPUR HUB",
      value: "KHARAGPUR HUB",
    },
    {
      lable: "KOLKATA AIRPORT TERMINAL HUB",
      value: "KOLKATA AIRPORT TERMINAL HUB",
    },
    {
      lable: "KOLKATA ECOM HUB",
      value: "KOLKATA ECOM HUB",
    },
    {
      lable: "LUCKNOW ECOM HUB",
      value: "LUCKNOW ECOM HUB",
    },
    {
      lable: "MATHURA HUB",
      value: "MATHURA HUB",
    },
    {
      lable: "MONDEAL ECOM HUB",
      value: "MONDEAL ECOM HUB",
    },
    {
      lable: "MUMBAI VIKHROLI ECOM HUB",
      value: "MUMBAI VIKHROLI ECOM HUB",
    },
    {
      lable: "MUMBAI-DAHISAR ECOM HUB",
      value: "MUMBAI-DAHISAR ECOM HUB",
    },
    {
      lable: "MUMBAI-FORT ECOM HUB",
      value: "MUMBAI-FORT ECOM HUB",
    },
    {
      lable: "NAVI MUMBAI-CBD BELAPUR ECOM HUB",
      value: "NAVI MUMBAI-CBD BELAPUR ECOM HUB",
    },
    {
      lable: "NAVI MUMBAI-PANVEL ECOM HUB",
      value: "NAVI MUMBAI-PANVEL ECOM HUB",
    },
    {
      lable: "NOIDA ECOM HUB",
      value: "NOIDA ECOM HUB",
    },
    {
      lable: "NOIDA HUB",
      value: "NOIDA HUB",
    },
    {
      lable: "RAJKOT ECOM HUB",
      value: "RAJKOT ECOM HUB",
    },
    {
      lable: "RANCHI HUB",
      value: "RANCHI HUB",
    },
    {
      lable: "SILIGURI HUB",
      value: "SILIGURI HUB",
    },
    {
      lable: "SURAT ECOM HUB",
      value: "SURAT ECOM HUB",
    },
    {
      lable: "SURAT HUB",
      value: "SURAT HUB",
    },
    {
      lable: "THANE-AMBERNATH ECOM HUB",
      value: "THANE-AMBERNATH ECOM HUB",
    },
    {
      lable: "THANE-DOMBIVALI ECOM HUB",
      value: "THANE-DOMBIVALI ECOM HUB",
    },
    {
      lable: "THANE(W)-RAILWAY STATION HUB",
      value: "THANE(W)-RAILWAY STATION HUB",
    },
    {
      lable: "VASAI ECOM HUB",
      value: "VASAI ECOM HUB",
    },
    {
      lable: "VILEPARLE ECOM HUB",
      value: "VILEPARLE ECOM HUB",
    },
    {
      lable: "YESHWANTHPUR HUB",
      value: "YESHWANTHPUR HUB",
    },
  ];
  const handleOnChange = (e) => {
    handlerHubId(e);

    let data = premises.filter(
      (i) => i?.premiseName.toLowerCase() === e.children.toLowerCase()
    );
    form.setFieldsValue({ hubZoon: data[0]?.zone });
  };

  const upperCase = (e, name) => {
    let splitStr = e.target.value.toLowerCase().split(" ");
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    form.setFieldValue(name, splitStr.join(" "));
  };

  let lg = 12;
  let sm = 24;
  let md = 12;
  let xs = 24;

  function validateInput(rule, value, callback) {
    if (/^\s/.test(value)) {
      callback("Input cannot start with a space!");
    } else {
      callback();
    }
  }

  let a = [
    "North 1",
    "North 2",
    "North East",
    "Central",
    "East",
    "West 1",
    "West 2",
    "South 1",
    "South 2",
    "SPL",
  ];
  return (
    <>
      <HeaderWithBottomLine text={"Basic Details"} icon={false} />

      <Row gutter={40} className="global-form-row basic-details-conten">
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="CPname"
            label={"CP name"}
            rules={[
              {
                required: true,
                message: "Please enter value",
              },
              { validator: validateInput },

              // () => ({
              //   validator(rule, value = "") {
              //     if (value.substring(1, 0) === " ") {
              //       return Promise.reject("Invalid CP name ");
              //     } else {
              //       return Promise.resolve();
              //     }
              //   },
              // }),
            ]}
            onKeyPress={(e) => {
              if (/[^A-Za-z ,:/\\-]/.test(e.key)) {
                e.preventDefault();
              }
              if (e.target.value.length >= 30) {
                e.preventDefault();
              }
            }}
          >
            <Input
              placeholder="Enter CP name"
              type="text"
              maxLength={50}
              disabled={disableInputField?.CPname}
              onInput={(e) => (e.target.value = e.target.value.toUpperCase())}

              // style={{ textTransform: "capitalize" }}
              // style={{ textTransform: "capitalize" }}
              // onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
              // onBlur={(e) => upperCase(e, "CPname")}
            />
          </Form.Item>
        </Col>

        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="CPtype"
            label={"CP type"}
            rules={[
              {
                required: true,
                message: "Please select value",
              },
            ]}
          >
            <Select
              // className="app-selector"
              disabled={disableInputField?.CPtype}
              placeholder="Select CP type"
              options={[
                {
                  value: "Booking",
                  label: "Booking",
                },
                {
                  value: "Delivery",
                  label: "Delivery",
                },
                {
                  value: "Booking & Delivery",
                  label: "Booking & Delivery",
                },
              ]}
            />
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="mineHubConnected"
            label={
              <span className="calculater-container-pikpin">
                Connected to a mini hub
              </span>
            }
          >
            <Radio.Group
              style={radioGap}
              onChange={(e) => setIsMiniHub(JSON.parse(e.target.value))}
              defaultValue={false}
              value={isMiniHub}
              rules={[
                {
                  required: true,
                  message: "Please select value",
                },
              ]}
            >
              <Radio value={true}>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>

        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="MotherHubName"
            label={
              <span className="calculater-container-pikpin">
                Mother hub name
              </span>
            }
            rules={[
              {
                required: true,
                message: "Please select value",
              },
            ]}
          >
            <Select
              // className="app-selector"
              showSearch
              placeholder="Select mini hub"
              // disabled={disableInputField?.MotherHubName}

              // options={miniHub}
            >
              {motherHubName.map((option) => (
                <Option key={option?.value} value={option?.value}>
                  {capitaliseWithHyphen(option?.lable)}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        {isMiniHub ? (
          <Col lg={lg} md={md} sm={sm} xs={xs}>
            <Form.Item
              name="miniHub"
              label={"Mini hub"}
              rules={[
                {
                  required: true,
                  message: "Please select value",
                },
              ]}
            >
              <Select
                // className="app-selector"
                disabled={disableInputField?.miniHub}
                showSearch
                placeholder="Select mini hub"
                // options={miniHub}
              >
                {miniHub.map((option) => (
                  <Option key={option?.value} value={option?.value}>
                    {capitaliseWithHyphen(option?.label)}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        ) : (
          ""
        )}

        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="RateCardType"
            label={
              <span className="calculater-container-pikpin">
                Rate card type
              </span>
            }
            rules={[
              {
                required: true,
                message: "Please select value",
              },
            ]}
          >
            <Select
              // className="app-selector"
              placeholder="Select card type"
              disabled={disableInputField?.RateCardType}
              options={[
                {
                  value: "Regular Slab ",
                  label: "Regular Slab ",
                },
                {
                  value: "Regular Piece ",
                  label: "Regular Piece ",
                },
                {
                  value: "Reverse Slab ",
                  label: "Reverse Slab ",
                },
                {
                  value: "Reverse Piece ",
                  label: "Reverse Piece ",
                },
              ]}
            />
          </Form.Item>
        </Col>

        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="billingCycle"
            label={
              <span className="calculater-container-pikpin">Billing cycle</span>
            }
            rules={[
              {
                required: true,
                message: "Please select value",
              },
            ]}
          >
            <Select
              // className="app-selector"
              placeholder="Select bill type"
              disabled={disableInputField?.billingCycle}
              options={[
                {
                  value: "Weekly",
                  label: "Weekly",
                },
                {
                  value: "Monthly",
                  label: "Monthly",
                },
                {
                  value: "Quarterly",
                  label: "Quarterly",
                },
              ]}
            />
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="hubZoon"
            label={"Hub zone"}
            rules={[
              {
                required: true,
                message: "Please enter value",
              },
            ]}
          >
            <Select
              // className="app-selector"
              showSearch
              placeholder="Select Zone"
              disabled={disableInputField?.hubZoon}

              // options={miniHub}
            >
              {a.map((option) => (
                <Option key={option} value={option}>
                  {option.toUpperCase()}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <HeaderWithBottomLine text={"Address Details"} icon={false} />
    </>
  );
};
